/**
 * Process Node Operation Log模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const configurationManagementOperationLog = {

  // 查询操作日志
  getConfigurationManagementOperationLogs(params) {
    return $http.post(`${global.API_URL}/sme/configurationManagementOperationLog/getConfigurationManagementOperationLogs`, params);
  }
}

export default configurationManagementOperationLog;



// WEBPACK FOOTER //
// ./src/api/configurationManagementOperationLog.js